import Image from 'next/image'
import { Heading, Button, Paragraph } from '~elements'
import styles from './ShowsCard.module.scss'
import { AssetProps, ButtonProps, RichTextType } from '~types'
import { fireAnalyticsEvent, getGtmLinkPosition } from '~analyticsUtils'
import { useRouter } from 'next/router'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { getImageUrl } from 'utils/assets/getImageUrl'
import type { MouseEvent } from 'react'

interface ShowsCardProps {
  image?: AssetProps
  imageRedirectUrl?: string
  buttonGroup?: Array<ButtonProps>
  headline?: string
  eyebrow?: string
  subheadline?: string
  description?: RichTextType
}

const ShowsCard = ({ buttonGroup, headline, eyebrow, description, imageRedirectUrl, image }: ShowsCardProps) => {
  const router = useRouter()

  const [source] = router.query.slug as string[]
  const imageUrl = getImageUrl({ imageUrl: image?.url })

  const handleCardClick = (e: MouseEvent<HTMLDivElement>) => {
    const targetEl = e.target as HTMLElement

    if (!targetEl.closest(`.${styles['btn-container']}`) && imageRedirectUrl) {
      router.push(imageRedirectUrl)
    }
  }

  return (
    <>
      <div
        className={styles['shows-card']}
        onClick={handleCardClick}
        style={{ cursor: imageRedirectUrl ? 'pointer' : 'default' }}
      >
        <div className={styles['image-container']}>
          {imageUrl && (
            <div className={styles['image-wrapper']}>
              <Image
                alt={image?.altText ?? headline ?? ''}
                src={imageUrl}
                fill
                style={{ objectFit: 'cover' }}
                quality={NEXT_IMAGE_QUALITY}
              />
            </div>
          )}
        </div>
        <div className={styles['shows-card-content']}>
          <div className={styles['shows-card-content__inner']}>
            {headline && <Heading level={2}>{headline}</Heading>}
            {eyebrow && (
              <Heading level={6} levelDisplay={'eyebrow'} color={'blue'}>
                {eyebrow}
              </Heading>
            )}
            {description && <Paragraph text={description} margin={'none'} />}
            {buttonGroup && buttonGroup.length > 0 && (
              <div className={styles['btn-container']}>
                {buttonGroup.map((button, index) => {
                  return (
                    <Button
                      {...button}
                      key={`${button.title}_${index}`}
                      analytics={{
                        linkPosition: getGtmLinkPosition(buttonGroup, index),
                        linkLocation: ShowsCard.displayName
                        // clickTracking={`${source}:${headline}:buy_tickets`}
                      }}
                    />
                  )
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

ShowsCard.displayName = 'shows_card'

export default ShowsCard
